import React from 'react'
import '../App.scss'

function BackLink() {
    const goBack = () => {
        window.history.back() // Переход назад в истории браузера
    }

    return (
        <button className="back-link main-text" onClick={goBack}>
            Вернуться назад
        </button>
    )
}

export default BackLink
